/** Superficie pública del bounded context Orders (pedidos online). */

export type {
  CustomerOrderRow,
  CustomerOrderDetail,
  CustomerOrderDiscountRow,
  CustomerOrderItemRow,
  CustomerOrderItemChange,
  OrderStatus,
  PickupType,
} from './domain/orderTypes';

export type { OrderActivityEvent } from '@shared/orderActivity';
export { formatOrderActivityEvent, formatOrderActivityTime } from '@shared/orderActivity';

export {
  ORDER_STATUS_LABELS,
  ORDER_STATUS_COLORS,
  ORDER_STATUS_FLOW,
  orderStatusSteps,
  orderStepperProgressIndex,
  canTransitionTo,
  canMerchantCancel,
  isPreparingDelayed,
  preparingSlaDeadlineMs,
  nextActionStatus,
  nextActionLabel,
  formatOrderItemOptionsLabel,
  formatOrderDisplayCode,
  formatOrderDisplayCodeLabel,
} from './domain/orderTypes';

export {
  fetchOpenOrders,
  countOpenOrders,
  fetchOrderHistory,
  fetchOrderById,
  fetchReplacementProducts,
  proposeOrderChange,
  updateOrderStatus,
  extendPreparingSla,
  refundOrder,
  CashSessionRequiredError,
} from './infra/ordersRepo';
export type {
  FetchOrderHistoryParams,
  FetchOrderHistoryResult,
  UpdateOrderStatusOptions,
  CompleteOrderResult,
} from './infra/ordersRepo';
export { formatCancelReasonLabel } from './domain/cancelReasonLabels';
export { OPEN_ORDER_STATUSES, historyStatusesForKind } from './domain/orderQueue';
export type { OrderHistoryKind } from './domain/orderQueue';
export {
  isMercadoPagoPaidOrder,
  isPayAtPickupOrder,
  needsCashSessionToComplete,
} from './domain/orderPayment';
export {
  formatCollectAndDeliverCta,
  type PickupCollectMethod,
} from './domain/orderCompletePayment';

export { OnlineOrdersScreen } from './screens/OnlineOrdersScreen';
export { OrdersHistoryScreen } from './screens/OrdersHistoryScreen';
export { OnlineOrderDetailScreen } from './screens/OnlineOrderDetailScreen';
export { OrderMessageThreadScreen } from './screens/OrderMessageThreadScreen';
export { OrderMessagesInboxScreen } from './screens/OrderMessagesInboxScreen';
export { useOrdersRealtime } from './hooks/useOrdersRealtime';
export { useOrderDetailRealtime } from './hooks/useOrderDetailRealtime';
